
import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="footer mt-auto py-3 bg-dark text-white">
      <Container className="text-center">
        <p>&copy; 2025 LionShield Private Bank. All Rights Reserved.</p>
        <p>Your Trusted Partner in Wealth Management.</p>
      </Container>
    </footer>
  );
};

export default Footer;
